import { SubscriptionStatus } from "../../../../OrderFlow/utils/orderFlowUtils";
import { useCompany } from "../../../../Shared/components/CompanyProvider/CompanyProvider";
import { ORDER_STATUS } from "../../../../Shared/utils/constants";
import { tokenReplace } from "../../../../Shared/utils/tokenReplacement";
import { OrderDetailsText } from "../utils/OrderDetailsAccordion-types";
import { buildForWeekStartingOn, buildMappedMeals, getOrderTotal, getOrderType, getOrderTypeDetails, } from "../utils/orderDetailsUtils";
export const useOrderDetailsAccordion = (currentOrder, companyConfig, skippedDays) => {
    var _a, _b, _c, _d;
    const { culture, tokenMap } = useCompany();
    const orderForWeekStartingOn = buildForWeekStartingOn(currentOrder, companyConfig === null || companyConfig === void 0 ? void 0 : companyConfig.startSunday);
    const companyText = (companyConfig === null || companyConfig === void 0 ? void 0 : companyConfig.companyText.length) ? companyConfig === null || companyConfig === void 0 ? void 0 : companyConfig.companyText : [];
    let noMealsSelectedText = (_b = (_a = companyText.find((text) => text.Title == "NoMealsSelectedText")) === null || _a === void 0 ? void 0 : _a.Text) !== null && _b !== void 0 ? _b : OrderDetailsText.MEALS_NOT_SELECTED;
    noMealsSelectedText = tokenReplace(noMealsSelectedText, true, tokenMap);
    const orderTotal = getOrderTotal(companyConfig, currentOrder, culture);
    const orderIsSkipped = ((_c = currentOrder.order.OrderMealDays) === null || _c === void 0 ? void 0 : _c.length) === 0 && ((_d = currentOrder.orderInfo.product_items) === null || _d === void 0 ? void 0 : _d.length) === 0;
    const mappedMeals = buildMappedMeals(currentOrder, skippedDays, noMealsSelectedText);
    const orderTypeInfo = getOrderType(currentOrder);
    const orderTypeDetails = getOrderTypeDetails(currentOrder);
    const showSubscriptionLinkId = currentOrder.order.OrderStatus === ORDER_STATUS.FUTURE ||
        currentOrder.order.SubscriptionStatus !== SubscriptionStatus.None;
    return {
        orderForWeekStartingOn,
        orderTotal,
        orderIsSkipped,
        mappedMeals,
        orderTypeInfo,
        orderTypeDetails,
        showSubscriptionLinkId,
    };
};
